enum OrdersViewColEnum {
    ACTIONS = "ACTIONS",
    ORDER = "ORDER",
    STATE = "STATE",
    VENDOR = "VENDOR",
    CREATED_AT = "CREATED_AT",
    UPDATED_AT = "UPDATED_AT",
    OTHER = "OTHER",
    USER = "USER",
    DUE_DATE = "DUE_DATE",
    CATALOG = "CATALOG",
    SHIP_DATE = "SHIP_DATE",
    ORDER_CATEGORIES = "ORDER_CATEGORIES",
}

export default OrdersViewColEnum;
